import * as Dialog from "@radix-ui/react-dialog";
import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useGlobalContext } from "../../GlobalContext";

export default function EditDriverModal({
  isOpen,
  onClose,
  driver,
  onDriverUpdated,
}) {
  
  const { baseurl, token, accessToken, teams, setIsUnauthorised ,AdminId} =
    useGlobalContext();
  const [form, setForm] = useState({
    userType: "driver",
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    startTime: "",
    endTime: "",
    teamId: "",
    transportType: "",
    transportDescription: "",
    licencePlate: "",
    tier: "",
    driverType: "",
  });

 useEffect(() => {
  if (isOpen && driver && teams?.length > 0) {
    const matchedTeam = teams.find((team) => team.team_name === driver.teamName);
    const resolvedTeamId = matchedTeam?.id || "";

    setForm({
      userType: "driver",
      firstName: driver.first_name || "",
      lastName: driver.last_name || "",
      email: driver.email || "",
      password: "",
      confirmPassword: "",
      startTime: driver.start_time || "",
      endTime: driver.end_time || "",
      teamId: resolvedTeamId,
      transportType: driver.transport_type || "",
      transportDescription: driver.transport_description || "",
      licencePlate: driver.licence_plate || "",
      tier: driver.tier || "",
      driverType: driver.driver_type || "",
    });
  }
}, [isOpen, driver, teams]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditDriver = async () => {
    if (form.password && form.password !== form.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    const payload = {
      driverId: driver.driverId,
      userType: form.userType,
      firstName: form.firstName,
      lastName: form.lastName,
      email: form.email,
      password: form.password,
      teamId: form.teamId,
      transportType: form.transportType,
      transportDescription: form.transportDescription,
      licencePlate: form.licencePlate,
      tier: form.tier,adminId:AdminId
    };

    try {
      const response = await axios.post(
        `${baseurl}/api/Driver/v1.0/editDriver`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.data.responseCode === "00") {
        toast.success("Driver updated successfully");
        onDriverUpdated?.();
        onClose();
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(response.data.responseMessage || "Failed to update driver");
      }
    } catch (err) {
      toast.error("Error occurred while updating driver");
    }
  };

  const handleUpdateDuty = async () => {
    if (!form.startTime || !form.endTime) {
      toast.error("Please select both start and end time");
      return;
    }

    if (!form.driverType) {
      toast.error("Please select driver type");
      return;
    }
    try {
      const response = await axios.post(
        `${baseurl}/api/Driver/v1.0/updateDriverDutyType`,
        {
          userid: driver.driverId,
          driverType: form.driverType,
          startTime: form.startTime,
          endTime: form.endTime,adminId:AdminId
        },
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (response.data.responseCode === "00") {
        toast.success("Driver duty time updated successfully!");
        onDriverUpdated?.();
        onClose();
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(
          response.data.responseMessage || "Failed to update driver duty time"
        );
      }
    } catch (error) {
      toast.error("Error occur while updating driver duty time");
    }
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/40 z-50" />
        <Dialog.Content className="bg-white p-6 rounded-md max-w-2xl w-full fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 space-y-4 max-h-[90vh] overflow-y-auto">
          <Dialog.Title className="text-lg font-semibold">
            Edit Driver
          </Dialog.Title>

          <div className="space-y-4">
            <h3 className="text-md font-medium text-gray-700 border-b pb-2">
              Driver Information
            </h3>
            <div className="grid grid-cols-2 gap-3 text-sm">
              <input
                name="firstName"
                value={form.firstName}
                onChange={handleChange}
                placeholder="First Name"
                className="border p-2 rounded"
              />
              <input
                name="lastName"
                value={form.lastName}
                onChange={handleChange}
                placeholder="Last Name"
                className="border p-2 rounded"
              />
              <input
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Email"
                className="border p-2 rounded col-span-2"
              />
              <input
                name="password"
                value={form.password}
                onChange={handleChange}
                type="password"
                placeholder="New Password"
                className="border p-2 rounded"
              />
              <input
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
                type="password"
                placeholder="Confirm Password"
                className="border p-2 rounded"
              />

              <select
                name="teamId"
                value={form.teamId}
                onChange={handleChange}
                className="border p-2 rounded col-span-2"
              >
                <option value="">Select Team</option>
                {teams.map((team) => (
                  <option key={team.id} value={team.id}>
                    {team.team_name}
                  </option>
                ))}
              </select>
              <input
                name="transportType"
                value={form.transportType}
                onChange={handleChange}
                placeholder="Transport Type"
                className="border p-2 rounded"
              />
              <input
                name="transportDescription"
                value={form.transportDescription}
                onChange={handleChange}
                placeholder="Transport Description"
                className="border p-2 rounded"
              />
              <input
                name="licencePlate"
                value={form.licencePlate}
                onChange={handleChange}
                placeholder="License Plate"
                className="border p-2 rounded"
              />
              <input
                name="tier"
                value={form.tier}
                onChange={handleChange}
                placeholder="Tier"
                className="border p-2 rounded"
              />
            </div>
          </div>

          <div className="flex justify-end gap-2 pt-4">
            <Dialog.Close asChild>
              <button className="bg-gray-200 text-sm px-4 py-2 rounded hover:bg-gray-300">
                Cancel
              </button>
            </Dialog.Close>
            <button
              onClick={handleEditDriver}
              className="bg-blue-600 text-white text-sm px-4 py-2 rounded hover:bg-blue-700"
            >
              Edit Driver
            </button>
          </div>

          <div className="space-y-4">
            <h3 className="text-md font-medium text-gray-700 border-b pb-2">
              Driver Duty Schedule
            </h3>
            <div className="space-y-3">
              <select
                name="driverType"
                value={form.driverType}
                onChange={handleChange}
                className="border p-2 rounded w-full"
              >
                <option value="">Select Driver Type</option>
                <option value="full_time">Full Time</option>
                <option value="part_time">Part Time</option>
              </select>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Choose Time
                </label>
                <div className="grid grid-cols-2 gap-2">
                  <input
                    type="time"
                    name="startTime"
                    value={form.startTime}
                    onChange={handleChange}
                    className="border p-2 rounded"
                    placeholder="Start Time"
                  />
                  <input
                    type="time"
                    name="endTime"
                    value={form.endTime}
                    onChange={handleChange}
                    className="border p-2 rounded"
                    placeholder="End Time"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-2 pt-4">
            <Dialog.Close asChild>
              <button className="bg-gray-200 text-sm px-4 py-2 rounded hover:bg-gray-300">
                Cancel
              </button>
            </Dialog.Close>
            <button
              onClick={handleUpdateDuty}
              className="bg-green-600 text-white text-sm px-4 py-2 rounded hover:bg-green-700"
            >
              Update Duty
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
